(function () {
  var STORAGE_KEY = 'cgt-color-mode';
  var root = document.documentElement;

  var ICON_DARK = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
  var ICON_LIGHT = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>';

  function isDark() {
    return root.getAttribute('data-theme') === 'dark';
  }

  function applyTheme(dark) {
    if (dark) {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
  }

  function updateButton() {
    var btn = document.getElementById('cgt-color-toggle');
    if (btn) {
      if (isDark()) {
        btn.setAttribute('aria-label', 'Switch to light mode');
        btn.innerHTML = ICON_DARK;
      } else {
        btn.setAttribute('aria-label', 'Switch to dark mode');
        btn.innerHTML = ICON_LIGHT;
      }
    }

    var mobileBtn = document.getElementById('cgt-color-toggle-mobile');
    if (mobileBtn) {
      if (isDark()) {
        mobileBtn.setAttribute('aria-label', 'Switch to light mode');
        var mobileIcon = mobileBtn.querySelector('svg');
        if (mobileIcon) mobileIcon.outerHTML = ICON_DARK;
        var mobileLabel = document.getElementById('cgt-color-toggle-mobile-label');
        if (mobileLabel) mobileLabel.textContent = 'Light mode';
      } else {
        mobileBtn.setAttribute('aria-label', 'Switch to dark mode');
        var mobileIcon = mobileBtn.querySelector('svg');
        if (mobileIcon) mobileIcon.outerHTML = ICON_LIGHT;
        var mobileLabel = document.getElementById('cgt-color-toggle-mobile-label');
        if (mobileLabel) mobileLabel.textContent = 'Dark mode';
      }
    }
  }

  // Apply saved or OS preference immediately — before body renders — to prevent flash
  var saved = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch (e) {}

  if (saved === 'dark') {
    applyTheme(true);
  } else if (saved === 'light') {
    applyTheme(false);
  } else {
    // No saved preference — fall back to OS setting
    var prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    applyTheme(prefersDark);
  }

  window.toggleColorMode = function () {
    var dark = !isDark();
    applyTheme(dark);
    try {
      localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    } catch (e) {}
    updateButton();
    // Clean up any scroll-lock classes Dawn leaves behind when toggle fires inside the mobile drawer
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');
  };

  document.addEventListener('DOMContentLoaded', function () {
    updateButton();
  });
})();
